module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//tiger_5_2.png?v=d846f938";